export function getCurrentSelection(state) {
    return state.currentSelection;
  }
  export function getReceptions(state) {
    return state.receptions;
  }
  